import type { StaticNavigationNavigationItemDto } from '@ori/static-api-client-react';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';

import { useIsMobile } from '../../hooks';

export interface NavigationTypeParams {
  link?: StaticNavigationNavigationItemDto;
  activeLinkType: StaticNavigationNavigationItemDtoLinkType;
}
export const useGetNavigationType = ({ link, activeLinkType }: NavigationTypeParams) => {
  const isMobile = useIsMobile();

  const isLinkTypeCatalogue = link?.linkType === StaticNavigationNavigationItemDtoLinkType.Catalogue;
  const isActiveLinkTypeCatalogue = activeLinkType === StaticNavigationNavigationItemDtoLinkType.Catalogue;
  const isCategory = activeLinkType === StaticNavigationNavigationItemDtoLinkType.Category;
  // @ts-expect-error -- check Static API typings
  const isInspiration = activeLinkType === 'Inspiration';

  return {
    isCatalogue: isMobile ? isLinkTypeCatalogue : isActiveLinkTypeCatalogue,
    isCategory,
    isInspiration,
  };
};
export interface GetBurgerMenuHeightParams {
  isActiveLink: boolean;
  isAlwaysActiveLink: boolean;
  burgerMenuHeight?: number;
}
export const getBurgerMenuHeight = ({
  isActiveLink,
  isAlwaysActiveLink,
  burgerMenuHeight,
}: GetBurgerMenuHeightParams) => {
  if (isActiveLink) {
    return burgerMenuHeight;
  } else if (isAlwaysActiveLink) {
    return undefined;
  }

  return 0;
};
